import React, { FC, Fragment } from 'react';
import { Grid, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { ParticipantView, QuestionView, ResponseView } from '@views';
import { useNavigationEligibility } from '@components/SurveyDrawer/NavigationEligibilityContextProvider';

interface AccountabilityPartnerResponseProps {
  currentQuestion: QuestionView;
  activeParticipants: ParticipantView[];
}

export const AccountabilityPartnerResponse: FC<AccountabilityPartnerResponseProps> = ({
  currentQuestion,
  activeParticipants,
}) => {
  const { triggerEligibility } = useNavigationEligibility();
  const handleAccountabilityPartnerResponse = (e: SelectChangeEvent<unknown>, opt: ResponseView) => {
    // const currentQuestion = questions[activeStep];
    const optIdx = currentQuestion.responses.findIndex((x) => x.id === opt.id);
    currentQuestion.responses[optIdx].textResponse = '';
    currentQuestion.responses.forEach((x) => {
      x.selected = false;
      x.textResponse = '';
    });
    currentQuestion.responses[optIdx].selected = true;
    currentQuestion.responses[optIdx].textResponse = String(e.target.value);
    triggerEligibility();
  };

  const currentStepResponses = currentQuestion.responses;
  return (
    <Fragment>
      {currentStepResponses.some((opt) => opt.responseType === 'AccountabilityPartner') &&
        currentQuestion.responses.map((opt) => {
          if (opt.responseType === 'AccountabilityPartner') {
            return (
              <Grid
                container
                key={opt.id}
                size={{ xs: 12 }}
                flexWrap={'wrap'}
                spacing={2}
                alignContent="center"
                justifyContent={'center'}
                display={'flex'}
                gap={2}
                paddingTop={2}
                paddingBottom={2}
              >
                <Select onChange={(e) => handleAccountabilityPartnerResponse(e, opt)}>
                  <MenuItem selected key={'default'} value={-1}>
                    No Preference
                  </MenuItem>
                  {activeParticipants.map((participant) => {
                    return (
                      <MenuItem value={participant.id} key={`participant-${participant.id}`}>
                        {participant.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </Grid>
            );
          }
          return null;
        })}
    </Fragment>
  );
};
